const sendGaEvent = eventParams => {
  gtag('event', eventParams.event, {
    event_category: eventParams.category,
    event_label: eventParams.label,
    value: 1,
    non_interaction: true,
    send_to: eventParams.trackingCode
  })
}

export default sendGaEvent



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/VideoPlayer/utils/sendGaEvent.js